
import { toObjectified } from 'api/baseApi';
import { Payload, usePost } from 'api/reactQuery/queryService';
import { Inline, IObjectified } from 'api/utils';
import { APIRoutes } from './constants';
import { ICustomerPricingCalculatorDetailResponse, ICustomerPricingCalculatorFacade } from 'api/swaggerTypes';
const CustomerPricingCalculatorResponseParser = (response: ICustomerPricingCalculatorDetailResponse): IObjectifiedCustomerPricingCalculatorDetailResponse => {
    const { CustomerPricingCalculator } = response;

    return {
        ...response,
        CustomerPricingCalculator: toObjectified(CustomerPricingCalculator as unknown as Inline<ICustomerPricingCalculatorFacade>)
    };
};

// Objectify Product Receipt Context
export type IObjectifiedCustomerPricingCalculatorDetailResponse = Omit<ICustomerPricingCalculatorDetailResponse, 'CustomerPricingCalculator'> & {
    CustomerPricingCalculator: IObjectified<ICustomerPricingCalculatorFacade>;
};

export const useCustomerPriceCodeCalculator = () => {
    return usePost<Payload<{ WarehouseEntity: string; ProductId: number; urlQueryParams: { CustomerId?: number; Initialise: boolean } } & ICustomerPricingCalculatorFacade>, IObjectifiedCustomerPricingCalculatorDetailResponse>
        (APIRoutes.customerPriceCode.calculator.calculate, null, { inline: true, responseParser: CustomerPricingCalculatorResponseParser });
};
